import { all, call } from "redux-saga/effects";
import appSagas from "./app/sagas";
import authSagas from "./auth/sagas";
import mapSagas from "./map/sagas";
import directionSagas from "./direction/sagas";
import placeSagas from "./place/sagas";

function* rootSaga() {
  yield all([
    call(appSagas),
    call(authSagas),
    call(mapSagas),
    call(directionSagas),
    call(placeSagas),
  ]);
}

export default rootSaga;
